import React from 'react'

const SomethingWentWrongPage = () => {
  return <>error</>
}

export default SomethingWentWrongPage;